// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"bb800aef","69":"2376a415","208":"affec1f1","223":"e31ab87f","338":"90d08641","405":"7261ae85","971":"8d70979b"}[chunkId] + ".chunk.css";
};